<template>
  <ViewContainer :breadcrumb="breadcrumbs" :title="$t('teams.teams')">
    <v-row class="mt-4">
      <v-col cols="12" lg="4" class="mb-6">
        <TeamInfo :team="team" :isLoading="isLoading" @updated="fetchTeam" />
      </v-col>

      <v-col cols="12" lg="8">
        <TeamActivity :team="team" />
      </v-col>
    </v-row>
  </ViewContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from '@/mixins/mixin.vue'
import api from '@/api'

import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'

import TeamActivity from './TeamActivity/TeamActivity.vue'
import TeamInfo from './TeamInfo/TeamInfo.vue'

export default {
  name: 'TeamDetailsView',

  props: {
    teamId: String,
  },

  components: {
    ViewContainer,
    TeamActivity,
    TeamInfo,
  },

  mixins: [mixin],

  data() {
    return {
      isLoading: true,
      team: {},
      prevRoute: null,
    }
  },

  mounted() {
    this.fetchTeam()
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },

  computed: {
    ...mapGetters(['organizationId']),

    breadcrumbs() {
      return [
        {
          to:
            this.prevRoute?.name === 'teams' // For the sake of UX we save the previous route state when user comes from the Team list.
              ? this.prevRoute
              : { name: 'teams' },
          name: this.$t('teams.team_list'),
          exact: true,
        },
        {
          to: { name: 'teamDetails', params: { teamId: this.teamId } },
          name: this.team.name || '...',
        },
      ]
    },
  },

  methods: {
    async fetchTeam() {
      try {
        const response = await api.teams.getTeamById(
          this.organizationId,
          this.teamId
        )
        this.team = response.data
      } catch (err) {
        this.checkNotFoundError(err)
        this.handleRequestError(err)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
